// extracted by mini-css-extract-plugin
export default {"wrapper":"IconItemList_wrapper__Zts7c","horizontal":"IconItemList_horizontal__UyhXe","item":"IconItemList_item__5GGf1","margin":"IconItemList_margin__1uwcc"};